import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Reveal, ChapterLabel } from "./Motion";
import { PhoneShot } from "./PhoneShot";
import { APP_SHOTS } from "../../data/content";

export const InsideCarousel = () => {
  const ref = useRef(null);
  const scrollByCard = (dir) => ref.current?.scrollBy({ left: dir * 300, behavior: "smooth" });

  return (
    <section id="inside" className="bg-cream py-24 sm:py-32 overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        <div className="flex items-end justify-between gap-6">
          <div>
            <Reveal><ChapterLabel index="A First Look" /></Reveal>
            <Reveal delay={0.1}>
              <h2 className="serif-display mt-8 max-w-2xl text-[2rem] sm:text-[2.7rem] lg:text-[3.4rem] font-light text-charcoal leading-[1.1]">
                Take a look inside HEARD.
              </h2>
            </Reveal>
          </div>
          <div className="hidden sm:flex gap-3">
            <button onClick={() => scrollByCard(-1)} data-testid="inside-prev" aria-label="Previous" className="flex h-11 w-11 items-center justify-center rounded-full border border-line bg-white text-sage-deep transition-colors hover:bg-sage hover:text-white hover:border-sage">
              <ChevronLeft size={18} />
            </button>
            <button onClick={() => scrollByCard(1)} data-testid="inside-next" aria-label="Next" className="flex h-11 w-11 items-center justify-center rounded-full border border-line bg-white text-sage-deep transition-colors hover:bg-sage hover:text-white hover:border-sage">
              <ChevronRight size={18} />
            </button>
          </div>
        </div>
        <Reveal delay={0.15}>
          <p className="mt-6 max-w-xl text-lg font-normal sm:font-light leading-relaxed text-ink/65">
            A real, working product built for calm — not clicks. Swipe through a few quiet moments from the app.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <span className="mt-6 inline-flex items-center gap-2 rounded-full border border-sage/30 bg-sage/10 px-3.5 py-1.5 text-[0.65rem] font-medium uppercase tracking-[0.18em] text-sage-deep">
            <span className="h-1.5 w-1.5 rounded-full bg-sage-deep" />
            Actual screens from the app
          </span>
        </Reveal>
      </div>

      <div
        ref={ref}
        className="mt-12 flex items-center gap-8 sm:gap-12 overflow-x-auto snap-x snap-mandatory px-[16vw] sm:px-[calc(50%-132px)] pb-8 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden"
        data-testid="inside-carousel"
      >
        {APP_SHOTS.map((s) => (
          <figure key={s.src} className="snap-center shrink-0 w-[60vw] max-w-[264px] sm:w-[264px]">
            <PhoneShot src={s.src} alt={s.caption} float />
            <figcaption className="mt-6 text-center text-[0.95rem] sm:text-sm font-normal sm:font-light leading-relaxed text-ink/70">{s.caption}</figcaption>
          </figure>
        ))}
      </div>

      <p className="mt-2 text-center text-xs uppercase tracking-[0.24em] text-taupe">Swipe or use the arrows to explore</p>
    </section>
  );
};
